import { Box, Typography } from "@mui/material";
import React, { useCallback, useRef } from "react";
import { useEffect } from "react";
import { useState } from "react";
import {
  getDrugListInArea,
  getEquipmentListInArea,
  getListOfAdvices,
  giveDrugToPatient,
} from "../../../../api/area";
import ExitCircleIcon from "../../../../assets/SVG/exitCircleIcon";
import PillIcon from "../../../../assets/SVG/pillIcon";
import DrugTable from "../../../leaderGroup/drug/drugTable";
import TableEquipment from "../../../leaderGroup/equipment/tableEquipment";
import SearchInput from "../../../project/searchInput";
import DrugTableInArea from "./drugTableInArea";
import ReturnAllDrugsPop from "./returnAllDrugsPop";
import TableUserDrug from "./tableUserDrug";

export default function DrugTableArea({ dataArea, equipment }) {
  const [dataDrugInArea, setDataDrugInArea] = useState();
  const [openReturnPop, setOpenReturnPop] = useState();
  const [dataUser, setDataUser] = useState();
  const [areaId, setAreaId] = useState();
  const [dataUser1, setDataUser1] = useState();
  const [mode, setMode] = useState("table");
  const [valueSearch, setValueSearch] = useState();
  const gridRef = useRef();
  
  const onFilterTextBoxChanged = useCallback(() => {
    gridRef.current.api.setGridOption(
      "quickFilterText",
      document.getElementById("filter-text-box").value
    );
  }, []);
  useEffect(() => {
    if (dataArea) {
      if (equipment) {
        getEquipmentListInArea(dataArea[0]?.areas[0].id)
          .then((x) => setDataDrugInArea(x))
          .catch(() => {});
      } else {
        getDrugListInArea(dataArea[0]?.areas[0].id)
          .then((x) => setDataDrugInArea(x))
          .catch(() => {});
        getListOfAdvices(
          dataArea[0]?.areas[0].id,
          "&deliveryStatus=NOT_DELIVERED"
        )
          .then((x) => setDataUser(x))
          .catch(() => {});
        getListOfAdvices(dataArea[0]?.areas[0].id, "&deliveryStatus=DELIVERED")
          .then((x) => setDataUser1(x))
          .catch(() => {});
      }
    }
  }, [dataArea]);

  useEffect(() => {
    if (equipment) {
      setMode("return");
    } else {
      setMode("table");
    }
  }, [equipment]);
  // console.log(dataArea);


  return (
    <Box>
      {dataDrugInArea?.length > 0 && (
        <ReturnAllDrugsPop
          areaId={dataArea[0]?.areas[0].id}
          open={openReturnPop}
          setOpen={setOpenReturnPop}
          equipment={equipment}
        />
      )}
      <Typography
        mt="40px"
        //   onClick={() => setSelected(0)}
        className={"styleSelectedTab"}
      >
        {equipment ? "تجهیزات" : "داروخانه"}
      </Typography>
      {!equipment && (
        <Box
          onClick={() => setMode("return")}
          sx={{ cursor: "pointer", width: "fit-content" }}
          mt="20px"
          display="flex"
        >
          <PillIcon />
          <Typography
            //   onClick={() => setSelected(0)}
            color="var(--emr-darkblue)"
            fontSize={"18px"}
          >
            {"مشاهده انبار داروها"}
          </Typography>
        </Box>
      )}
          <SearchInput
            type="text"
            id="filter-text-box"
            onInput={onFilterTextBoxChanged}
            value={valueSearch}
            onChange={(e) => setValueSearch(e.target.value)}
            mb="5px"
            mr="20px"
          />
      {dataUser && (
        <>
          {mode === "table" && (
            <TableUserDrug
              rowData={dataUser}
              areaId={dataArea[0]?.areas[0].id}
              gridRef={gridRef}
              // handleClick={handleClick}
            />
          )}
          {mode === "table" && (
            <TableUserDrug
              areaId={dataArea[0]?.areas[0].id}
              rowData={dataUser1}
              notDelivered
              gridRef={gridRef}
              // handleClick={handleClick}
            />
          )}
        </>
      )}
      {mode === "return" && (
        <>
          {dataDrugInArea?.length > 0 && !equipment && (
            <DrugTableInArea gridRef={gridRef}  rowData={dataDrugInArea} />
          )}
          {dataDrugInArea?.length > 0 && equipment && (
            <TableEquipment
              tableArea
              gridRef={gridRef}
              rowData={dataDrugInArea}
            />
          )}

          <Box>
            <Box
              mt="20px"
              borderRadius={"11px"}
              width={"fit-content"}
              gap="10px"
              bgcolor="var(--emr-darkblue)"
              display={"flex"}
              alignItems="center"
              p="5px 10px"
              onClick={() => setOpenReturnPop(!openReturnPop)}
              sx={{ cursor: "pointer" }}
            >
              <ExitCircleIcon />
              <Typography color="white">
                {equipment ? "بازگشت به تجهیزات" : "بازگشت به داروخانه"}
              </Typography>
            </Box>
          </Box>
        </>
      )}
    </Box>
  );
}
